module.exports = __webpack_public_path__ + "img/pencil-landscape_jp.32cae4a.jpg";